exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".p-hdg-centered[data-v-5397aadd]{margin-top:0;padding-top:0}\n", ""]);
